// extracted by mini-css-extract-plugin
export default {"wrapper":"SubHeader_wrapper__HLM3q","wrapper_size":"SubHeader_wrapper_size__bjNd5"};